import React, { useState, useEffect, useMemo } from 'react';
import { Box, Paper, Title } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import { useQuery, useLazyQuery } from '@apollo/client';

import '@fontsource/orbitron/700.css'; // For bold weight

import RepairsDepartmentScorecardTabSet from './RepairsDepartmentScorecardTabSet';

const RepairsDepartmentScorecard = () => {
    return (
        <Paper 
            shadow="md" 
        
            style={{ 
                maxWidth: '100%', 
               
            }}
        >
            <Title 
                order={1}
                style={{ 
                    fontFamily: 'Orbitron, sans-serif',
                    color: '#FDB813',
                    fontStyle: 'italic',
                    fontSize: '1.5rem',
                    marginBottom: 0,
                    textAlign: 'left'
                }}
            >
                Repairs Department Scorecard
            </Title>
            <Box style={{ marginTop: 0 }}>
                <RepairsDepartmentScorecardTabSet />
            </Box>
        </Paper>
    );
};

export default RepairsDepartmentScorecard;